module.exports = __webpack_public_path__ + "img/15.7e9081e8.jpg";